export default __webpack_public_path__ + "static/media/calendar.ae3341f4.svg";